import { render, staticRenderFns } from "./ResourcesScreen.vue?vue&type=template&id=3957e44a&scoped=true"
import script from "./ResourcesScreen.vue?vue&type=script&lang=js"
export * from "./ResourcesScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3957e44a",
  null
  
)

export default component.exports